module.exports = __webpack_public_path__ + "a6b2a268e3c69db169324b079ac86939.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/titles.png
// module id = 537
// module chunks = 0